import React from "react";
import { iconCreateBot } from "assets/icons";
import { Button } from "components/Button";
import PropTypes from "prop-types";
import { MisplacedBrokerModalContainer } from "./MisplacedBrokerModal.styles";

export const MisplacedBrokerModal = (props) => {
  return (
    <MisplacedBrokerModalContainer
      heading=""
      {...props}
      className="misplaced-broker-wrapper"
    >
      <div className="logo-img">
        <img src={iconCreateBot} className="img" />
      </div>
      <div className="heading-space">
        <h3 className="heading">We are working to connect more brokers</h3>
      </div>
      <div className="btn-ok">
        <Button onClick={props.onHide} label="Ok" width="80%" />
      </div>
    </MisplacedBrokerModalContainer>
  );
};

MisplacedBrokerModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};
